import React from "react";
import Text from '../../Global/Text';
import PropTypes from "prop-types";

export const CompactPrce = ({ className, userData }) => {
  const getTotalPrice = () => {
    let price = 0;
    let combinedPrices = 9.5;
    userData.basketList.forEach(element => {
      const chosenName = `chosenPackage-${element}`;
      const packageName = userData[chosenName];
      if (userData.quotes && userData.quotes[packageName]) {
        if(userData.combinedPrice) {
          combinedPrices += (Number(userData.quotes[packageName].priceApiResponse[0].offeredPrice.priceWithFee) - 9.5);
        }
        else
          price += Math.round(userData.quotes[packageName].priceApiResponse[0].offeredPrice.priceWithFee);
      }
      if(userData.combinedPrice && combinedPrices > 9.5){
        price = Math.round(combinedPrices);
      }
    });
    return price;
  }

  return (
    <label className={className || 'form__label'} >
      <strong>
        {getTotalPrice()} <Text value="$[units.$[paymentFrequency]]" />
      </strong>
    </label>
  )
}

CompactPrce.defaultProps = {
  className: ""
}

CompactPrce.propTypes = {
  userData: PropTypes.object.isRequired,
  className: PropTypes.string
}